<app-group-info-view
  [mode]="mode"
  [data]="data"
  [members]="members"
  [isChannel]="isChannel"
  [memberCount]="memberCount"
  [initFilter]="initFilter"
  [allowEditing]="allowEditing$ | async"
  [allowDeleting]="allowDeleting$ | async"
  [allowSubscribing]="allowSubscribing"
  [allowSpecialFieldsViewing]="allowSpecialFieldsViewing"
  [loading]="loading"
  [membersLoading]="membersLoading"
  (startEditing)="onStartEditing()"
  (saved)="onSaveData($event)"
  (canceled)="onCancel()"
  (deleted)="openConfirmDialog()"
  (deletePhoto)="onDeletePhoto()"
  (subscribed)="onSubscribe()"
  (unsubscribed)="onUnsubscribe()"
  (updateMembers)="refreshMembers()"
></app-group-info-view>

<ng-template #confirmDialogTemplate let-observer>
  <p>{{ 'common.dialogs.areYouSureTitle' | translate }}</p>
  <div *ngIf="allowDeletingFromTelegram" class="tui-space_bottom-3" waitTelegramChats>
    <label [tuiBlock]="tuiElementMediumSize">
      {{ 'components.groupInfo.labels.deleteFromTelegram' | translate }}
      <input tuiCheckbox type="checkbox" [(ngModel)]="deleteFromTelegram" [size]="'s'" />
    </label>
  </div>
  <button
    tuiButton
    type="button"
    class="tui-space_right-3"
    [size]="tuiElementMediumSize"
    (click)="applyDelete(observer)"
  >
    {{ 'common.buttons.yes' | translate }}
  </button>
  <button tuiButton type="button" appearance="secondary" [size]="tuiElementMediumSize" (click)="observer.complete()">
    {{ 'common.buttons.no' | translate }}
  </button>
</ng-template>
